import { Injectable } from "@angular/core";
import { Observable, throwError } from "rxjs";
import {
    HttpClient,
    HttpHeaders,
    HttpErrorResponse,
} from "@angular/common/http";
import { NgBlockUI, BlockUI } from "ng-block-ui";
import { environment } from "../../../environments/environment";
import { map, catchError, finalize } from "rxjs/operators";

interface CertificateResponse {
    statusCode: number;
    body: any;
}

interface CertificateDownloadResponse {
    certificateUrl: string;
}

@Injectable()
export class CertificatesService {
    @BlockUI() blockUI: NgBlockUI;
    private readonly apiCertificatesPath = environment.URL_API_CERTIFICATES;
    private readonly headers = new HttpHeaders().set(
        "Content-Type",
        "application/json"
    );

    constructor(private readonly http: HttpClient) {}

    validarDatos(request: {
        codSucursalBusqueda: number;
        codRamo: number;
        nroPoliza: number;
        nroEndoso: number;
        nroDocumentoBroker: string;
    }): Observable<CertificateResponse> {
        this.blockUI.start();
        const body = {
            ...request,
            type: "query",
        };
        return this.http
            .post<CertificateResponse>(
                `${this.apiCertificatesPath}/query`,
                body,
                { headers: this.headers }
            )
            .pipe(
                map((response) => response),
                catchError((error: HttpErrorResponse) => {
                    console.error("Error validando certificado:", error);
                    return throwError(error);
                }),
                finalize(() => {
                    this.blockUI.stop();
                })
            );
    }

    generarCertificado(request) {
        this.blockUI.start();
        const body = {
            ...request,
            type: "generate",
        };
        return this.http
            .post(`${this.apiCertificatesPath}/generar`, body, {
                headers: this.headers,
            })
            .pipe(
                map((response) => response),
                catchError((error: HttpErrorResponse) => {
                    console.error("Error generando certificado:", error);
                    return throwError(error);
                }),
                finalize(() => {
                    this.blockUI.stop();
                })
            );
    }
}
